import styled from 'styled-components';
import NormalA from '../A';

const A = styled(NormalA)`
  padding: 2em 0;
`;

export default A;
